export const TestimonialsSection = () => `
  <section class="py-20 bg-primary" data-aos="fade-up">
    <div class="container mx-auto px-6">
      <h2 class="text-4xl font-bold text-center mb-16">Hva sier kundene våre?</h2>
      <div class="testimonial-swiper">
        <div class="swiper-wrapper">
          ${[
            {
              name: 'Chris J.',
              text: 'Veldig flott produkt! Minstemannen er stor fornøyd!',
              product: 'Sagababy Kjøkkenhjelper',
              rating: 5,
              date: 'Nov 7, 2024'
            },
            {
              name: 'Christian F.',
              text: 'Guttungen elsker den og super leveringstid 🤩',
              product: 'Sagababy Sammenleggbar Sklie',
              rating: 5,
              date: 'Nov 3, 2024'
            },
            {
              name: 'Christian F.',
              text: 'Fornøyd! Guttungen elsker den og super leveringstid',
              product: 'Scandicommerce AS',
              rating: 5,
              date: 'Nov 3, 2024'
            }
          ].map(testimonial => `
            <div class="swiper-slide">
              <div class="testimonial-card">
                <div class="flex items-center gap-4 mb-4">
                  <div>
                    <h4 class="font-semibold">${testimonial.name}</h4>
                    <p class="text-sm text-gray-600">${testimonial.product}</p>
                    <p class="text-sm text-gray-400">${testimonial.date}</p>
                  </div>
                </div>
                <div class="flex mb-3 text-secondary">
                  ${'★'.repeat(testimonial.rating)}
                </div>
                <p class="text-gray-700">${testimonial.text}</p>
              </div>
            </div>
          `).join('')}
        </div>
        <div class="swiper-pagination"></div>
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
      </div>
    </div>
  </section>
`;